import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, Platform, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useState } from 'react'
import * as FileSystem from 'expo-file-system';
import Colours from '../../utils/Colours'
import { TouchableOpacity } from 'react-native';
import { useQuery } from '@tanstack/react-query'
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import NoticeAlertComp from '../../alertComp/NoticeAlertComp';
import ErrorAlertComp from '../../alertComp/ErrorAlertComp';
import SuccessAlertComp from '../../alertComp/SuccessAlertComp';
import * as ImageManipulator from 'expo-image-manipulator';

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;


const PostToPullandTable = ({ image, setShowPostToPullandTable, setShowPostingPicture }) => {

    const [noticeMessage, setNoticeMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [isTables, setIsTables] = useState(false)
    const [isCelebratory, setIsCelebratory] = useState(false)
    const [selectedTable, setSelectedTable] = useState(null)
    const [selectedCelebratory, setSelectedCelebratory] = useState(null);
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isNoticeAlertVisible, setIsNoticeAlertVisible] = useState(false)

    const axiosPrivate = useAxiosPrivate()


    const { data: tablesWithMoney, isLoading: isLoadingTablesWithMoney, refetch: refetchTablesWithMoney, error: errorTablesWithMoney } = useQuery({
        queryKey: ['tablesWithMoney'],
        queryFn: async () => {
            //console.log(" Running query for tablesWithMoney");

            const response = await axiosPrivate.get("/tablesWithMoney/tablesWithMoney");
            //console.log(" Data received:", response.data);

            return response.data;
        },
        onError: (error) => {
            Toast.show({
                type: 'error',
                text1: 'Error Fetching tables',
                text2: error.message || "Something went wrong!",
            });
        },
    });


    //Also work on fetching and displaying tables you joined, so you can post to such tables

    const { data: rescentUserCelebratories, isLoading: isLoadingRescentUserCelebratories, refetch: refetchRescentUserCelebratories, error: errorRescentUserCelebratories } = useQuery({
        queryKey: ['rescentUserCelebratories'],
        queryFn: async () => {
            //console.log(" Running query for rescentUserCelebratories");

            const response = await axiosPrivate.get("/getRecentUserCelebratories/getRecentUserCelebratories");
            //console.log(" Data received:", response.data);

            return response.data;
        },
        onError: (error) => {
            Toast.show({
                type: 'error',
                text1: 'Error Fetching tables',
                text2: error.message || "Something went wrong!",
            });
        },
    });


    const formatDate = (isoString) => {
        if (!isoString) return ''; // Handle empty or undefined input

        const date = new Date(isoString);

        if (isNaN(date)) return ''; // Handle invalid dates

        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' }); // Use short month name (e.g., Jun)
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure 2-digit minutes
        const period = hours >= 12 ? 'PM' : 'AM'; // AM/PM format
        const formattedHour = hours % 12 || 12; // Convert to 12-hour format

        // Function to add suffix (st, nd, rd, th) to the day
        const getDayWithSuffix = (day) => {
            if (day > 3 && day < 21) return `${day}th`; // Special case for 11-13
            switch (day % 10) {
                case 1: return `${day}st`;
                case 2: return `${day}nd`;
                case 3: return `${day}rd`;
                default: return `${day}th`;
            }
        };

        return {
            date: `${getDayWithSuffix(day)} ${month} ${year}`,
            time: `${formattedHour}:${minutes} ${period}`
        };
    };


    const prepareImageForUpload = async (imageUri) => {
        try {
            const fileInfo = await FileSystem.getInfoAsync(imageUri);

            if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
                // Already under 1MB, return as-is
                //console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
                return imageUri;
            }

            //console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
            let compressRatio = 0.9;
            let compressed = null;

            while (compressRatio > 0.1) {
                compressed = await ImageManipulator.manipulateAsync(
                    imageUri,
                    [],
                    {
                        compress: compressRatio,
                        format: ImageManipulator.SaveFormat.JPEG,
                    }
                );

                const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

                if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
                    console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
                    return compressed.uri;
                }

                compressRatio -= 0.1;
            }

            console.warn('Could not get image under 1MB. Returning best attempt.');
            return compressed ? compressed.uri : imageUri;

        } catch (error) {
            console.error('Image compression failed:', error);
            return imageUri; // fallback to original
        }
    };

    const prepareImagesForUpload = async (imageUris) => {
        const compressedImages = await Promise.all(
            imageUris.map((uri) => prepareImageForUpload(uri))
        );
        return compressedImages;
    };

    const handleSendPhotoToTable = (tableSelected) => {
        setIsTables(true)
        setSelectedTable(tableSelected)
        //console.log('selectedTable', tableSelected)
        setNoticeMessage(`Send photo to the table - "${tableSelected?.tableCaption}"`)
        setIsNoticeAlertVisible(true)
    }
    const handleSendPhotoToCelebratory = (celebratorySelected) => {
        setIsCelebratory(true)
        setSelectedCelebratory(celebratorySelected)
        //console.log('selectedCelebratory', celebratorySelected)
        setNoticeMessage(`Send photo to the Pull - "${celebratorySelected?.celebratoryCaption}"`)
        setIsNoticeAlertVisible(true)
    }
    const handlePostPhotoToCelebratory = async (celebratory) => {

        const celebratoryId = celebratory?._id;
        //console.log('celebratory', celebratoryId)
        if (!celebratoryId) {
            // maybe show an error, or prevent the form submission
            return
        }

        const formData = new FormData()

        try {
            setIsLoading(true)

            let processedImages = [];

            if (Array.isArray(image) && image.length > 0) {

                // processedImages = image //we will no longer be compressing images

                processedImages = await prepareImagesForUpload(image);
                // //console.log('Compressed Images:', processedImages);


                processedImages.forEach((uri, index) => {
                    const uriParts = uri.split('.');
                    const fileType = uriParts[uriParts.length - 1].toLowerCase();

                    formData.append('images', {
                        uri: Platform.OS === 'ios' ? uri.replace('file://', '') : uri,
                        type: `image/${fileType}`,
                        name: `photo_${index + 1}.${fileType}`,
                    });
                });

            }

            formData.append('celebratoryId', celebratoryId);

            // **Proceed to submit to the database**
            setIsLoading(true);

            const celebratoryResponse = await axiosPrivate.post('/postPhotoToCelebratory/postPhotoToCelebratory', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (celebratoryResponse.status === 200 || celebratoryResponse.status === 201) {
                setIsNoticeAlertVisible(false)
                setSuccessMessage(celebratoryResponse.data.message)
                setIsSuccessCompVisible(true)

            } else {
                setIsNoticeAlertVisible(false)
                setErrorMessage('Unexpected response')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            //console.log('Errors', error)
            // if (error.response) {
            //     //console.error('Error response from server:', error.response.data);
            //     setIsNoticeAlertVisible(false)
            //     const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
            //     setErrorMessage(errorMessages);
            //     setIsErrorCompVisible(true);

            // }
            // else if (error.request) {
            //     //console.error('No response received:', error.request);
            //     setIsNoticeAlertVisible(false)
            //     setErrorMessage('No response Recieved check your internet')
            //     setIsErrorCompVisible(true)
            // }
            if (error) {
                //console.error('Error setting up the request:', error.message);
                setIsNoticeAlertVisible(false)
                //  setErrorMessage(error.message || 'Unexpected error occurred')
                setErrorMessage('Unexpected error occurred, try again later')
                setIsErrorCompVisible(true)
            }

        } finally {
            setIsLoading(false);
        }

    }

    const handlePostPhotoToTables = async (tableData) => {
        const tableId = tableData?._id;
        //console.log('tableId', tableId)
        if (!tableId) {
            return
        }

        const formData = new FormData()

        try {
            setIsLoading(true)

            let processedImages = [];

            if (Array.isArray(image) && image.length > 0) {

                processedImages = await prepareImagesForUpload(image);
                // //console.log('Compressed Images:', processedImages);

                // processedImages = image //We will no longer be compressing images

                processedImages.forEach((uri, index) => {
                    const uriParts = uri.split('.');
                    const fileType = uriParts[uriParts.length - 1].toLowerCase();

                    formData.append('images', {
                        uri: Platform.OS === 'ios' ? uri.replace('file://', '') : uri,
                        type: `image/${fileType}`,
                        name: `photo_${index + 1}.${fileType}`,
                    });
                });

            }

            formData.append('tableID', tableId);

            // **Proceed to submit to the database**
            setIsLoading(true);

            const tableResponse = await axiosPrivate.post('/postPhotoToTables/postPhotoToTables', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (tableResponse.status === 200 || tableResponse.status === 201) {
                setIsNoticeAlertVisible(false)
                setSuccessMessage(tableResponse.data.message)
                setIsSuccessCompVisible(true)

            } else {
                setIsNoticeAlertVisible(false)
                setErrorMessage('Unexpected response')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            //console.log('Errors', error)
            // if (error.response) {
            //     //console.error('Error response from server:', error.response.data);
            //     setIsNoticeAlertVisible(false)
            //     const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
            //     setErrorMessage(errorMessages);
            //     setIsErrorCompVisible(true);

            // }
            // else if (error.request) {
            //     //console.error('No response received:', error.request);
            //     setIsNoticeAlertVisible(false)
            //     setErrorMessage('No response Recieved check your internet')
            //     setIsErrorCompVisible(true)
            // }else {
            if (error) {
                //console.error('Error setting up the request:', error.message);
                setIsNoticeAlertVisible(false)
                // setErrorMessage(error.message || 'Unexpected error occurred')
                setErrorMessage('Unexpected error occurred, try again later')
                setIsErrorCompVisible(true)
            }

        } finally {
            setIsLoading(false);
        }
    }

    if (isLoadingRescentUserCelebratories || !rescentUserCelebratories || isLoadingTablesWithMoney) {
        return (
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
            </View>
        );
    }

    const uniqueNames = [...new Set(rescentUserCelebratories.map(c => c.creatorName).filter(Boolean))];

    // Get unique creator userIDs (to exclude from participants)
    const creatorIDs = new Set(rescentUserCelebratories.map((c) => c.userID?.toString()));

    // Get all participant user IDs, flatten and filter out creators
    const allParticipantIDs = rescentUserCelebratories.flatMap((c) => c.participants || []);
    const participantIDsExcludingCreators = allParticipantIDs.filter(
        (id) => !creatorIDs.has(id.toString())
    );

    const othersCount = new Set(participantIDsExcludingCreators.map(String)).size;

    // Build name string
    const namePart = uniqueNames.length > 1
        ? `${uniqueNames.slice(0, 2).join(', ')}`
        : uniqueNames[0] || 'Someone';


    return (
        <ScrollView
            style={styles.componentStyle}
            contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
            showsVerticalScrollIndicator={false}
        >
            <View>

                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(20), fontFamily: 'Sen-Bold' }}>
                    Tables
                </Text>
                {tablesWithMoney?.length > 0 ? (<View style={styles.tableListStyle}>
                    <FlatList
                        data={tablesWithMoney}
                        scrollEnabled={false}
                        keyExtractor={(tables) => tables._id}
                        renderItem={({ item: table }) => (
                            <TouchableOpacity style={styles.atable}
                                onPress={() => handleSendPhotoToTable(table)}
                            >
                                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Medium' }}>
                                    {table.tableCaption}
                                </Text>
                            </TouchableOpacity>)} />
                </View>) : (
                    <TouchableOpacity style={styles.atable}>
                        <Text style={{ color: Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Medium' }}>
                            No active tables
                        </Text>
                    </TouchableOpacity>)
                }


                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(20), fontFamily: 'Sen-Bold' }}>
                    Pulls
                </Text>
                {rescentUserCelebratories?.length > 0 ? (
                    <>
                        <View style={styles.pullsNotice}>
                            <Text style={{ color: Colours.PRIMARY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Medium', textAlign: 'center' }}>
                                {namePart}
                                {othersCount > 0
                                    ? ` and ${othersCount} others celebrate you, share a photo.`
                                    : ' celebrates you, share a photo.'}
                            </Text>
                        </View>

                        <View style={styles.bodyContainer}>

                            <FlatList
                                data={rescentUserCelebratories}
                                scrollEnabled={false}
                                keyExtractor={(pulls) => pulls._id}
                                renderItem={({ item: pulls }) => (

                                    <TouchableOpacity
                                        style={styles.tablesListContainer2}
                                        onPress={() => { handleSendPhotoToCelebratory(pulls) }}>
                                        <View style={styles.profileContainer}>
                                            <View style={styles.profileSubContainer}>
                                                <Image source={{ uri: pulls?.userID?.profilePicture }} style={styles.userImage} />
                                                {/* <Image source={require('../../../assets/imagePlaceholder.jpg')} style={styles.userImage} /> */}
                                                <Text style={styles.profileText} >BY: {pulls?.creatorName}</Text>
                                            </View>
                                            <View>
                                                <Text style={styles.dateText} >{formatDate(pulls?.createdAt).date}</Text>
                                                <Text style={styles.timeText} >{formatDate(pulls?.createdAt).time}</Text>
                                            </View>
                                        </View>

                                        <View style={styles.tableListTitlesContain}>
                                            <View style={{ display: 'flex', gap: 4 }}>
                                                <Text style={styles.celebratoryCaptionTxt}>{pulls?.celebratoryCaption}</Text>
                                                <Text style={styles.selectedTagsTxt}>{pulls?.selectedTags}</Text>
                                                <View style={styles.tableValueContainer}>
                                                    <View style={styles.pullValueContainer}>
                                                        <Text style={styles.pullText}>{pulls?.celebratoryDoingsAmt?.length} JOINED</Text>
                                                    </View>
                                                </View>
                                            </View>
                                            {/* <Image source={{ uri: pulls?.image }}
                                                style={styles.partyImgSmall} /> */}
                                            <Image
                                                source={{ uri: pulls?.images?.length > 0 ? pulls.images[0]?.url : pulls?.image }}
                                                style={styles.partyImgSmall}
                                            />
                                        </View>
                                        <View style={{ height: 1, backgroundColor: Colours.LIGHTGRAY, marginVertical: 5, marginBottom: 10 }} />
                                    </TouchableOpacity>
                                )
                                } />

                        </View>
                    </>
                ) : (
                    <TouchableOpacity style={styles.atable}>
                        <Text style={{ color: Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Medium' }}>
                            No active Pulls
                        </Text>
                    </TouchableOpacity>

                )}


            </View>











            <Modal
                visible={isNoticeAlertVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsNoticeAlertVisible(false)}
            >
                <NoticeAlertComp
                    message={noticeMessage}
                    isLoading={isLoading}
                    onClose={() => {
                        if (isCelebratory) {
                            setNoticeMessage('Just a sec.., your image is processing, this might take a while for larger images')
                            handlePostPhotoToCelebratory(selectedCelebratory)
                        } else {
                            setNoticeMessage('Just a sec.., your image is processing, this might take a while for larger images')
                            handlePostPhotoToTables(selectedTable)
                        }


                    }}
                    onCancel={() => setIsNoticeAlertVisible(false)}
                />
            </Modal>

            <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
            >
                <SuccessAlertComp
                    message={successMessage}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                        setShowPostToPullandTable(false)
                        setShowPostingPicture(false)
                    }}
                />
            </Modal>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>

        </ScrollView>
    )
}

export default PostToPullandTable

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        display: 'flex',
        // margin: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        // borderRadius: dynamicSize(15),
        height: '100%',
    },
    tableListStyle: {
        display: 'flex',
        //gap: dynamicSpacing(20),
        backgroundColor: Colours.PRIMARY_LIGHTER,
        borderRadius: dynamicSize(10),
        padding: dynamicSpacing(15),
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
    },
    pullsNotice: {
        display: 'flex',
        //gap: dynamicSpacing(20),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        padding: dynamicSpacing(15),
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),

    },
    atable: {
        display: 'flex',
        width: '100%',
        height: dynamicSize(35),
        paddingTop: dynamicSpacing(10),
        paddingBottom: dynamicSpacing(10),

        // backgroundColor: 'blue'
    },
    bodyContainer: {
        // margin: width * 0.03,
        marginBottom: 0,
        padding: 15,
        backgroundColor: 'white',
        borderRadius: 15,
        shadowColor: '#E8E8E8'
    },
    giverHeaders: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    createdForByText: {
        paddingBottom: width * 0.02,
        fontSize: dynamicFontSize(14),
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    tablesListContainer2: {
        paddingBottom: 10,
        gap: 2,
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 5,
        gap: 5,
    },
    profileSubContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
    },
    userImage: {
        width: width * 0.09,
        height: width * 0.09,
        borderRadius: 99,
    },
    profileText: {
        fontSize: dynamicFontSize(14),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
        width: width * 0.4,
    },
    dateText: {
        fontSize: dynamicFontSize(14),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
        textAlign: 'right',
    },
    timeText: {
        fontSize: dynamicFontSize(12),
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
        textAlign: 'right',
    },
    tableListTitlesContain: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
    },
    celebratoryCaptionTxt: {
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(16),
        fontFamily: 'Sen-Bold',
        width: width * 0.5,
    },
    selectedTagsTxt: {
        color: Colours.PRIMARY,
        fontSize: dynamicFontSize(14),
        fontFamily: 'Sen-Regular',
        width: width * 0.5,
    },
    tableValueContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '75%',
    },
    pullValueContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        width: '75%',
    },
    pullText: {
        color: Colours.DARKLIGHTGRAY,
        fontSize: dynamicFontSize(12),
        fontFamily: 'Sen-Regular',
    },
    pullValue: {
        color: Colours.PRIMARY,
        fontSize: dynamicFontSize(14),
        fontFamily: 'Sen-Bold',
    },
    partyImgSmall: {
        width: width * 0.18,
        height: width * 0.15,
        borderRadius: width * 0.04,
    },


})